<template>
  <div id="report_header" v-bind:class="$mq">
    <div v-bind:style="{'font-size' : $mq == 'sm' ? '1.25rem' : '1.75rem'}">XRP Network Status</div>
    <div v-if="have_selected"><b>{{selected_report_period}}</b>: {{selected_report_timestamp}}</div>
    <div v-else><b>Last updated</b>: <span id="report_last_updated">{{last_updated}} <sup>UTC</sup></span></div>
  </div>
</template>

<script>
export default {
  name: 'ReportHeader',

  computed : {
    selected_report : function(){
      return this.$store.state.report.selected;
    },

    selected_report_period : function(){
      return this.selected_report.period.charAt(0).toUpperCase() +
             this.selected_report.period.substr(1);
    },

    selected_report_timestamp : function(){
      return this.selected_report.timestamp;
    },

    have_selected : function(){
      return !!this.selected_report.period;
    },

    ///

    last_updated : function(){
      return this.$store.state.report.retrieved.replace("T", " ").replace(/\..*Z/, "");
    },
  },
}
</script>

<style scoped>
#report_header.sm{
  font-size: 0.8em;
}
</style>
